export const root = {
  path: "/",
  getLink: () => "/",
};
